import { Component, Input, OnInit } from "@angular/core";
import { CONSTANTS } from "../../../../config";
import { LocalService, ManagerService } from "../../../../core";

@Component({
  selector: "app-account-participation-content",
  templateUrl: "./account-participation-content.component.html",
  styleUrls: ["./account-participation-content.component.scss"]
})
export class AccountParticipationContentComponent implements OnInit {
  @Input() isPracticeLead: boolean = false;
  @Input() isAdminUser: boolean = false;
  userProfile: any;
  companyTypePreferences = CONSTANTS.companyTypePreferences;
  isChallengePreference: boolean = false;
  isSalesChallenge: boolean = false;
  salesIncentiveFlag: boolean = false;
  enablementsIncentiveFlag: boolean = false;
  companyPreferencesData: any[] = [];
  preferencesIds: any[] = [];
  companyClaimingTypePreferences = CONSTANTS.companyClaimingTypePreferences;
  selectedLanguage: string = "";

  constructor(private managerService: ManagerService) {}

  ngOnInit(): void {
    this.userProfile = LocalService.get("userProfile");
    const lang = localStorage.getItem("selectedLanguage");
    this.selectedLanguage = lang ? lang : "English";
    this.initializeLanguagePreferences();
    this.getCompanyPreferences();
  }

  initializeLanguagePreferences(): void {
    if (this.selectedLanguage === "Korean") {
      this.companyTypePreferences = CONSTANTS.korean_companyTypePreferences;
    } else if (this.selectedLanguage === "Japanese") {
      this.companyTypePreferences = CONSTANTS.japanese_companyTypePreferences;
    }
  }

  getCompanyPreferences(): void {
    if (this.userProfile.company && this.userProfile.company.id) {
      const companyParams = {
        companyId: this.userProfile.company.id,
      };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data: any) => {
          const preference = data.companyPreferences.find(
            (item: any) => item.name === "COMPANY_SALES_CHALLENGES_AND_REWARDS"
          );
          const SalesChallenge = data.companyPreferences.map(
            (item: any) => item.enabled
          );
          this.isSalesChallenge = SalesChallenge[0];
          if (preference) {
            this.isChallengePreference = preference.enabled;
          }
          this.preferencesIds = data.companyPreferences.reduce(
            (activePreferences: any[], item: any) => {
              if (item.enabled) {
                activePreferences.push(item.id);
              }
              return activePreferences;
            },
            []
          );
          this.matchCompanyPreferences();
          this.salesIncentiveFlag = this.companyTypePreferences[0].enabled;
          this.enablementsIncentiveFlag =
            this.companyTypePreferences[1].enabled;
          this.companyPreferencesData = data.companyPreferences.map(
            (item: any) => item.enabled
          );
        }
      );
    }
  }

  matchCompanyPreferences(): void {
    this.companyTypePreferences.map((item: any) => {
      if (this.preferencesIds.includes(item.id)) {
        item.enabled = true;
      } else {
        item.enabled = false;
      }
    });

    this.companyClaimingTypePreferences.map((item: any) => {
      if (this.preferencesIds.includes(item.id)) {
        item.enabled = true;
      } else {
        item.enabled = false;
      }
    });
  }
}
